class TransitionContainer extends HTMLElement {
  constructor() {
    super();
    this.debug = false;
    this.cookieNameClicks = 'click_count';
    this.cookieNameShown = 'shown_count';
    this.count = parseInt(this.getCookie(this.cookieNameClicks)) || 0;
    this.shown = parseInt(this.getCookie(this.cookieNameShown)) || 0;
  }
  connectedCallback() {
    this.video = this.querySelector('video');
    this.urls = this.getAttribute('data-video-urls').split(',');
    const randomIndex = Math.floor(Math.random() * this.urls.length);
    const sourceElement = document.createElement('source');
    sourceElement.src = this.urls[randomIndex];
    sourceElement.type = 'video/mp4';
    this.video.appendChild(sourceElement);
    this.videoEndedHandler = this.onVideoEnded.bind(this);
    this.pageshowHandler = this.onPageShow.bind(this);
    document.addEventListener('click', this.clickHandler.bind(this));
    window.addEventListener('pageshow', this.pageshowHandler);
    this.video.addEventListener('ended', this.videoEndedHandler);
  }

  clickHandler(e) {
    if (e.metaKey || e.ctrlKey) {
      this.log('skipping metaKey or ctrlKey');
      return;
    }

    const link = e.target.closest('a');
    if (!link) {
      this.log('skipping no anchor ancestor');
      return;
    }

    const disabled = e.target.closest('[data-transition-disabled]');
    if (disabled) {
      this.log('skipping due to disabled ancestor', disabled);
      return;
    }

    const panelTrigger = e.target.closest('[data-panel-transition]');
    if (panelTrigger) {
      this.log('skipping panel trigger');
      return;
    }

    if (!link.href.startsWith(window.location.origin)) {
      this.log('skipping invalid', link.href);
      return;
    }

    if (link.href.includes('#')) {
      this.log('skipping hashlink', link.target);
      return;
    }

    if (link.target) {
      this.log('skipping target', link.target);
      return;
    }

    this.incrementClicks();
    if (this.count === this.calculateClickTarget()) {
      this.incrementShown();
      e.preventDefault();
      this.targetUrl = link.href;
      this.video.play();
      this.classList.remove('hidden');
      document.body.style.overflow = 'hidden';
    }
  }

  onPageShow(event) {
    if (event.persisted) {
      this.classList.add('hidden');
      document.body.style.overflow = '';
    }
  }

  onVideoEnded(event) {
    window.location.href = this.targetUrl;
  }

  calculateClickTarget() {
    const n = this.shown + 1;
    return (3 / 2) * n ** 2 - (3 / 2) * n + 1;
  }

  log(label, value) {
    if (this.debug) {
      console.log('transition ' + label + ':', value);
    }
  }

  incrementClicks() {
    this.count += 1;
    this.setCookie(this.cookieNameClicks, this.count);
  }

  incrementShown() {
    this.shown += 1;
    this.setCookie(this.cookieNameShown, this.shown);
  }

  getCookie(name) {
    let matches = document.cookie.match(
      new RegExp('(?:^|; )' + name.replace(/([.$?*|{}()[]\\\/+^])/g, '\\$1') + '=([^;]*)'),
    );
    return matches ? decodeURIComponent(matches[1]) : undefined;
  }

  setCookie(name, value, options = {}) {
    options = {
      path: '/',
      value: '1',
    };

    if (options.expires instanceof Date) {
      options.expires = options.expires.toUTCString();
    }

    let updatedCookie = encodeURIComponent(name) + '=' + encodeURIComponent(value);

    for (let optionKey in options) {
      updatedCookie += '; ' + optionKey;
      let optionValue = options[optionKey];
      if (optionValue !== true) {
        updatedCookie += '=' + optionValue;
      }
    }

    document.cookie = updatedCookie;
  }
}

customElements.define('transition-container', TransitionContainer);
